import { render } from "./FolderCircleIcon.vue?vue&type=template&id=6ea84160"
import script from "./FolderCircleIcon.vue?vue&type=script&lang=js"
export * from "./FolderCircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__